module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("86dX7"))).then(() => parcelRequire('1iHdE'));